import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setStatus(data.message || "If an account exists for that email, a reset link has been sent.");
    } catch (err) {
      setStatus("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form onSubmit={submit} className="bg-white shadow-md rounded-lg p-8 w-full max-w-sm">
        <img src="/logo.png" alt="Jybek Homecare Services" className="h-16 w-auto mx-auto mb-4" />
        <h1 className="text-xl font-bold mb-1 text-center" style={{ color: "#154E93" }}>
          Reset Your Password
        </h1>
        <p className="text-sm text-gray-500 mb-6 text-center">
          Enter your email and we'll send you a link to set a new password.
        </p>

        {status && (
          <div className="mb-4 text-sm bg-blue-50 text-blue-700 px-3 py-2 rounded">{status}</div>
        )}

        <label className="block text-sm font-medium mb-1">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border rounded px-3 py-2 mb-6 text-sm"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full text-white font-medium py-2 rounded"
          style={{ backgroundColor: "#154E93" }}
        >
          {loading ? "Sending…" : "Send Reset Link"}
        </button>

        <Link to="/" className="block text-center text-xs text-gray-500 hover:text-gray-700 mt-4 underline">
          Back to Sign In
        </Link>
      </form>
    </div>
  );
}
